import React, { type FC } from 'react';

import { Box, type BoxProps, xcss } from '@atlaskit/primitives';

const fixedSizeStyle = xcss({
	width: '312px',
});

const fullSizeStyle = xcss({
	width: '100%',
});

const borderBoxStyle = xcss({
	borderRadius: '16px',
	borderColor: 'color.border',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	backgroundColor: 'elevation.surface',
});

export const AnalyticsBorderBox: FC<{
	padding?: BoxProps<'div'>['padding'];
	testId?: string;
	shouldFitContainer?: boolean;
	children?: React.ReactNode;
}> = ({ children, padding, shouldFitContainer = true, testId }) => (
	<Box
		padding={padding || 'space.400'}
		xcss={[borderBoxStyle, shouldFitContainer ? fullSizeStyle : fixedSizeStyle]}
		as="div"
		testId={testId}
	>
		{children}
	</Box>
);
